import { render, staticRenderFns } from "./DialogSupport.vue?vue&type=template&id=3504ad10"
import script from "./DialogSupport.vue?vue&type=script&lang=js"
export * from "./DialogSupport.vue?vue&type=script&lang=js"
import style0 from "./DialogSupport.vue?vue&type=style&index=0&id=3504ad10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports